<template>
  <div>
    <div class="descWrap">
      <div class="headWraps">
        <div class="topTitle">
          <img src="@/assets/images/left.png" @click="gotoNotice">
          <div class="title">{{ title }}</div>
        <!-- 公告中心 -->
        </div>
      </div>
      <div class="infoWrap">
        <el-row>
          <!-- <el-col :span="5" class="noticeTlt">
            <div>
              <span
              >返回</span>
            </div>
          </el-col> -->
          <el-col>
            <!-- <el-col :span="24">
              <div class="noticeTitle">
                {{ title }}
              </div>
            </el-col> -->
            <div style="padding-top:30px">
              <div class="cardContent" v-html="content" />
            </div>
            <div style="text-align:center">
              <img :src="imgUrl" alt="" style="width:90%;height:auto;">
            </div>
            <el-col :span="24" class="timeWrap">
              <!-- <img v-show="time" src="../../../assets/images/noticeLogo.png" style="height:45px"> -->
              <span>{{ time }}</span>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
export default {
  name: 'NoticeDetail',
  data() {
    return {
      currentclassifyId: 2,
      isCurrentId: this.$route.params.articleId,
      content: '',
      sign: '',
      title: '',
      time: '',
      imgUrl: '',

      ismore: '查看更多',
      selectnPage: window.sessionStorage.getItem('selectnPage'),
      param_getArticle: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    // const currentTab = window.sessionStorage.getItem('selectnPage')
    this.getArticle(this.isCurrentId)
  },
  methods: {
    gotoNotice() {
      this.$router.push('/notice/noticelist')
    },

    gotoIndex() {
      this.$router.push('/index')
    },

    getArticle(id) {
      const that = this
      // const localeLanguage = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      this.param_getArticle = protocol.param_getContentDetails
      this.param_getArticle.param.id = id
      http.getRes(this.param_getArticle).then(response => {
        const { code, message, value } = response.data
        if (code == '0') {
          that.imgUrl = value.titleImg
          that.title = value.title
          that.content = value.content
          that.time = global.util.dateDayFormate(Number(value.createTime))
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.descWrap {
  width: 100%;
  margin: 0 auto;
  background-color: #141625;
  min-height: calc(100vh - 50px);
  .infoWrap{
    width: 1200px;
    min-height: 845px;
    margin: 0 auto;
    background: #3B3E4E;
    margin-top: 30px;
    padding: 40px;
    .el-row{
      text-align: left;
      margin: 0;
    }
  }
}
.noticeTitle{
  font-weight: 600;
  font-size: 20px;
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #FFFFFF;
  padding-bottom: 11px;
  text-align: center;
}
.timeWrap{
  text-align: right;
  font-size: 20px;
  font-weight: 600;
  padding-top: 100px;
  span{
    color: #fff;
  }
}
.headWraps{
  height: 40px;
  // background: linear-gradient(180deg, #1F243C 0%, #323855 100%);
  position: relative;
}
.topTitle {
  height: 40px;
  background: linear-gradient(180deg, #1F243C 0%, #323855 100%);
  position: fixed;
  width:100%;
  padding: 0 40px;
  display: flex;
  align-items: center;
  img {
    width: 19px;
    height: 17px;
    cursor: pointer;
  }
  .title{
    flex: 1;
    padding-right: 19px;
    text-align: center;
    font-size: 24px;
    font-family: PingFang HK-Semibold, PingFang HK;
    font-weight: 600;
    color: #FFFFFF;
  }
}
.noticeTlt {
  cursor: pointer;
  height: 65px;
  background-color: transparent;
  line-height: 65px;
  font-family: 'Alibaba PuHuiTi-Regular, Alibaba PuHuiTi';
  font-weight: 200;
  color: #2483FF;
  font-size: 29px;
  padding-left: 20px;
  span{
    border: 2px solid #2483FF;
    border-radius: 4px;
    padding: 6px 10px;
  }
}
.noticeTlt /deep/ .el-input__inner {
  background-color: transparent;
  height: 30px;
  border-radius: 15px;
  font-size: 14px;
  overflow: hidden;
  // border: 1px solid rgba(64,144,253,1);
  border: none;
  background: #263562;
  color: #fff;
}
.noticeTlt /deep/ .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #fff;
  font-size: 14px;
}

.noticeTlt /deep/ .el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #fff;
  font-size: 14px;
}

.noticeTlt /deep/ .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #fff;
  font-size: 14px;
}
.currentId {
  color: #2483ff;
}
.titleClass {
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  cursor: pointer;
}
.more {
  color: #5f82f9;
  cursor: pointer;
  margin-top: 10px;
}
.cardContent {
  /deep/ p {
    color: #fff;
    margin: 10px 0 !important;
    font-size: 18px;
  }
}
</style>
